import {ReactComponent as Illustration} from '@hconnect/uikit/src/lib2/pages/illustration500.svg'
import {Card, Grid, GridProps} from '@mui/material'
import React from 'react'
import {ErrorBoundary} from 'react-error-boundary'
import {useLocation} from 'react-router'

export interface WidgetErrorBoundaryProps {
  children: React.ReactNode
  gridProps?: Omit<GridProps, 'item' | 'zeroMinWidth'>
}

// Wraps a widget to catch errors in its body (hooks, early logic) that happen before children render
export const WidgetErrorBoundary = ({children, gridProps}: WidgetErrorBoundaryProps) => {
  const {pathname} = useLocation()

  return (
    <ErrorBoundary
      fallback={
        <Grid item zeroMinWidth {...gridProps}>
          <Card
            sx={{
              padding: 3,
              pr: 1,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Illustration style={{width: '100%'}} viewBox="0 0 401 316" />
          </Card>
        </Grid>
      }
      resetKeys={[pathname]}
    >
      {children}
    </ErrorBoundary>
  )
}
